import React from "react";
import PropTypes from "prop-types";
import { graphql } from "gatsby";
import MediaWrapper from "@/components/mediaWrapper";
import MarkdownWrapper from "@/components/markdownWrapper";

export const query = graphql`
  fragment TeamFullWidthWithVerticalImagesData on StrapiComponentTeamFullWidthWithVerticalImages {
    topic
    title
    description
    teamMember {
      jobTitle
      memberName
      description
      profilePhoto {
        ...StrapiMediaSubquery
      }
    }
  }
`;

function FullWidthWithVerticalImages({ data }) {
  if (!data) {
    return <template />;
  }
  return (
    <div className="bg-background-white">
      <div className="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:px-8 lg:py-24">
        <div className="space-y-12">
          <div>
            {data.topic && (
              <h3 className="text-base font-semibold uppercase tracking-wider text-text-primary">
                <MarkdownWrapper text={data.topic} />
              </h3>
            )}
            {data.title && (
              <h2 className="mt-2 text-3xl font-extrabold tracking-tight text-text-primary sm:text-4xl">
                <MarkdownWrapper text={data.title} />
              </h2>
            )}
            {data.description && (
              <MarkdownWrapper
                text={data.description}
                markdownClassName="mt-5 max-w-prose text-xl text-text-secondary"
                replaceParagraph={false}
              />
            )}
          </div>
          {Boolean(data.teamMember?.length) && (
            <ul className="space-y-12 lg:grid lg:grid-cols-2 lg:items-start lg:gap-x-8 lg:gap-y-12 lg:space-y-0">
              {data.teamMember.map((person, index) => (
                <li key={index}>
                  <div className="space-y-4 sm:grid sm:grid-cols-3 sm:gap-6 sm:space-y-0 lg:gap-8">
                    {person.profilePhoto && (
                      <MediaWrapper
                        media={person.profilePhoto}
                        divClassName="aspect-[3/4] w-[50%] sm:w-full"
                        className="rounded-lg shadow-lg"
                      />
                    )}
                    <div className="sm:col-span-2">
                      <div className="space-y-4">
                        <div className="space-y-1 text-lg font-medium leading-6">
                          {person.memberName && <h3>{person.memberName}</h3>}
                          {person.jobTitle && (
                            <MarkdownWrapper
                              text={person.jobTitle}
                              markdownClassName="custom-font text-text-primary"
                            />
                          )}
                        </div>
                        {person.description && (
                          <div className="text-lg">
                            <MarkdownWrapper
                              text={person.description}
                              markdownClassName="text-text-secondary"
                              replaceParagraph={false}
                            />
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </li>
              ))}
            </ul>
          )}
        </div>
      </div>
    </div>
  );
}

FullWidthWithVerticalImages.propTypes = {
  data: PropTypes.object,
};

export default FullWidthWithVerticalImages;
